import React from "react";
import "./menutitle.css";

export class MenuTitle extends React.Component {
    public render(){
        return (
            <div className="header">
                <span className="title">
                    Petra & Beni
                </span>
            </div>
        )
    }
}
